import { render, staticRenderFns } from "./SocietyDashView.vue?vue&type=template&id=57b66216&scoped=true"
import script from "./SocietyDashView.vue?vue&type=script&lang=js"
export * from "./SocietyDashView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b66216",
  null
  
)

export default component.exports